import { initialQueryState } from "common/utils/utils"
import { documentosSelector } from "features/Documentos/redux/documentosSlice"
import { useSelector } from "hooks/useSelector"
import { useCallback, useEffect, useState } from "react"

const useFetchTurboTable = ({
  fetchItems,
  mapItems,
  customHandleQueryState,
}: $TSMigrationFixMe) => {
  const [items, setItems] = useState<Array<object>>([])
  const [isLoading, setIsLoading] = useState(false)
  const [totalCount, setTotalCount] = useState(0)
  const [queryState, setQueryState] = useState()
  const [isError, setIsError] = useState(false)
  const { isVerDocumentoModalShowing } = useSelector(documentosSelector)
  const totalItems: $TSMigrationFixMe = []

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true)
      const res = await fetchItems()?.(queryState || initialQueryState)
      const tableData = mapItems ? mapItems(res) : res.data.items || res.data
      setTotalCount(res?.data?.totalCount)
      setItems(tableData)
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
  }, [queryState, fetchItems, mapItems])

  useEffect(() => {
    if (!isVerDocumentoModalShowing && fetchData) {
      fetchData()
    }
  }, [
    customHandleQueryState,
    fetchData,
    isVerDocumentoModalShowing,
    queryState,
  ])

  return {
    items,
    isLoading,
    totalCount,
    queryState,
    totalItems,
    isError,
    setQueryState,
    setIsLoading,
    fetchTableData: fetchData,
  }
}

export default useFetchTurboTable
